import React, { Component } from "react";
import PropTypes from "proptypes";

export default class TermsAndConditions extends Component {
  state = {
    termsAndConditionDoc: this.props.registration ? this.props.registration : {}
  };

  render() {
    let paragraphText = "";
    let buttonText = "";
    if (this.state.termsAndConditionDoc.status === "Approved") {
      paragraphText = "Your document has been completed and approved!";
      buttonText = "View Document";
    } else {
      if (this.state.termsAndConditionDoc.status === "Uploaded") {
        paragraphText =
          "Thanks for completing the document! Check back soon to see an updated status, once we're able to review the document.";
        buttonText = "View Document";
      } else {
        paragraphText =
          "Please click on the link below to read and complete the Registration Form for your trip.";
        buttonText = "Let's Go!";
      }
    }
    return (
      <div>
        {this.state.termsAndConditionDoc.reasonDeclined ? (
          <div className="col-md-12 warning-text-container">
            <p className="warning-color">
              {this.state.termsAndConditionDoc.reasonDeclined}
            </p>
          </div>
        ) : (
          ""
        )}
        <div>
          <p>{paragraphText}</p>
          <br />
          <button
            onClick={() => this.props.openModal("termsAndConditionsModal")}
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

TermsAndConditions.propTypes = {
  registration: PropTypes.shape({}).isRequired,
  openModal: PropTypes.func.isRequired
};
